import { env } from '../env';
import { bureauService } from '../service/bureaus-service';

import {
  operadoresService
} from '../service/operadores-service'

import { cookieUtils } from './cookie.utils'
import { jwtUtils } from './jwt.utils';
import { configuracaoPendenteService } from '../service/configuracao-pendente-service';
import { configuracaoService } from '../service/configuracao-service';


class AcessoUtils {
  constructor() { }

  redirecionarSemTokenParaLogin() {
    if (cookieUtils.verificarCookie('jwt')) return;

    window.location = `//${env.econtadorFront}`;
  }

  async adquirirOperadorLogado() {
    const operador = await operadoresService.listarOperadorAtual();
    return operador;
  }

  async adquirirUserConnection() {
    const userConnection = await bureauService.adquirirUserConnection();
    return userConnection;
  }

  extrairPermissoesDoOperadorEmObjeto(operador) {
    const permissoesString = operador.data.attributes.permissoes;
    const permissoesObject = JSON.parse(permissoesString);
    return permissoesObject;
  }

  extrairTipoDeUsuarioEmString(operador) {
    const user = operador.data.attributes;
    const tipoConvertido = user.tipo.toUpperCase().includes("COLABORADOR")
      ? "Operador"
      : "Cliente";
    return tipoConvertido;
  }

  extrairTipoDeUsuarioEmEnum(operador) {
    const user = operador.data.attributes;
    const tipoConvertido = user.tipo.toUpperCase().includes("COLABORADOR")
      ? 1
      : 2;
    return tipoConvertido;
  }

  isUserContador(operador) {
    const tipoUsuarioEnum = this.extrairTipoDeUsuarioEmEnum(operador);
    return tipoUsuarioEnum == 1;
  }

  isOperadorAdmin(operador) {
    const isAdministrador = operador?.data?.attributes?.administra;
    return isAdministrador;
  }

  isOperadorSuperAdm(operador) {
    const isSuperAdm =  operador?.data?.id == 1 ? true : false;
    return isSuperAdm;
  }

  converterUserConnectionDominioParaMenu(userConnection) {
    const conversao = {
      Current: {}
    };
    conversao.Current.UtilizaVersaoFreemium = userConnection.freemium;
    conversao.Current.UtilizaPackCND = userConnection.cnder;
    conversao.Current.UtilizaConciliador = userConnection.collecter;
    conversao.Current.UtilizaPackCRM = userConnection.crmer;
    conversao.Current.UtilizaKaroo = userConnection.karooer;
    conversao.Current.UtilizaTarefasWeb = userConnection?.tareferWeb;
    conversao.Current.IsPilotoTarefas = userConnection?.isPilotoTarefas;
    conversao.Current.UtilizaAutomacaoExtrato = userConnection?.utilizaeExtrato;
    conversao.Current.UtilizaRadarEcac = userConnection?.utilizaRadarEcac;

    if(userConnection.pacote && userConnection.pacote.recursos)
    {
      conversao.Current.Pacote = { Id: userConnection.pacote.id, Recursos: []};
      conversao.Current.Pacote.Recursos = userConnection.pacote.recursos.map( recurso => {
       return {Id: recurso.id, Descricao: recurso.descricao}
      });
    }

    if (userConnection.recursosEmFasePiloto) {
      conversao.Current.RecursosEmFasePiloto = userConnection.recursosEmFasePiloto.map((recurso) => {
        return { Id: recurso.id, Descricao: recurso.descricao, EmFasePiloto: recurso.EmFasePiloto };
      });
    }

    return conversao;
  }

  adquirirIsFreemiumFaltandoInformacoesDoContador(userConnection) {
    return userConnection?.isFreemiumFaltandoInformacoesDoContador
  }

  adquirirEDecodificarJWT() {
    if (!cookieUtils.verificarCookie('jwt')) return '';
    const token = cookieUtils.adquirirCookie('jwt');
    return jwtUtils.DecodificarJWT(token);
  }

  adquirirUWDDoUsuarioLogado() {
    const decodedToken = this.adquirirEDecodificarJWT();
    const UWD = decodedToken.uwd;
    return UWD;
  }

  adquirirCRMDoUsuarioLogado() {
    const decodedToken = this.adquirirEDecodificarJWT();
    return decodedToken.crm;
  }

  async getConfiguracaoPendente() {
    return await configuracaoPendenteService.getConfiguracaoPendente();
  }

  hasConfiguracaoPendente(configuracaoPendente) {
    const isDataInicioTarefasWebFaltando = configuracaoPendente.dataInicioTarefasWeb == null;
    const isDepartamentoPadraoFaltandoConfigurar = configuracaoPendente.departamentosPadraoFaltantes.length != 0;
    return isDataInicioTarefasWebFaltando || isDepartamentoPadraoFaltandoConfigurar; 
  }

  getPessoaLogada(operador, userConnection) {
    const pessoaLogada = {
      Permissoes: this.extrairPermissoesDoOperadorEmObjeto(operador),
      isSuperAdm: this.isOperadorSuperAdm(operador),
      Administrador: this.isOperadorAdmin(operador),
      TipoDePessoa: this.extrairTipoDeUsuarioEmEnum(operador),
      IsContador: this.isUserContador(operador),
      IsFreemiumFaltandoInformacoesDoContador: this.adquirirIsFreemiumFaltandoInformacoesDoContador(userConnection),
      nome: operador?.data?.attributes?.nome,
      login: operador?.data?.attributes?.login,
      email: operador?.data?.attributes?.email
    };
    
    if (Array.isArray(operador?.included)) {
      const fotoObject = operador.included.find(included => included.type == 'fotos');
      pessoaLogada.foto = fotoObject?.attributes?.imagem;
    }

    return pessoaLogada;
  }

  async loadPessoaLogada(operador, userConnection) {
    if(!operador) {
      operador = await this.adquirirOperadorLogado();
    }
    
    if(!userConnection) {
      userConnection = await this.adquirirUserConnection();
    }

    return this.getPessoaLogada(operador, userConnection);
  }

  async getEstiloPersonsonalizado(key) {
    return await configuracaoService.getEstiloPersonsonalizado(key); 
  }
}

export const acessoUtils = new AcessoUtils()